import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const WindowCleaning = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my window cleaning business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps window cleaning businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for window cleaning businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most window cleaning businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my window cleaning business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like window cleaning. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Window Cleaning - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Window Cleaning CRM", url: "/industries/window-cleaning" }
  ];

  const industryData = {
    name: 'Window Cleaning',
    title: 'Stop Missing Seasonal Rush & Build Year-Round Recurring Revenue',
    subtitle: 'Capture booking requests instantly, automate seasonal reminders, and convert one-time cleans into regular maintenance',
    icon: '🪟',
    challenges: [
      'Seasonal fluctuations in bookings',
      'Hard to get commercial contracts',
      'One-time residential customers never return',
      'Weather causes constant rescheduling',
      'Difficult to estimate jobs over the phone'
    ],
    solutions: [
      'Automated seasonal reminder campaigns',
      'Commercial client nurture sequences',
      'Recurring service plan automation',
      'Weather-based rescheduling alerts',
      'Online quote calculator with photos'
    ],
    features: [
      'Client CRM with service history',
      'Seasonal marketing automation',
      'Commercial contract management',
      'Weather-based notifications',
      'Online estimate tool',
      'Before/after galleries',
      'Recurring service tracking',
      'Review automation'
    ],
    results: [
      '70% residential convert to quarterly',
      '3x more commercial contracts',
      'Consistent revenue year-round',
      '£4.6K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Window Cleaning UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for window cleaning businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for window cleaning UK, window cleaning business software, window cleaning customer management, window cleaning lead generation UK"
        url="/industries/window-cleaning"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default WindowCleaning;